import React, { useState, useEffect, useRef } from "react";
import { BASE_URL, BASE_URL_PREBID } from "../config/axios";
import axios from "axios";
import { SearchBig } from "./AllSvg";
import Select from "react-select";
import { CSSForFilterDropdown } from "./custom";


const Projectname = ({ projectName, setProjectName, assignTO }) => {

    const [projectNameList, setProjectNameList] = useState([]);
    const role = sessionStorage.getItem("role");


    const getProjectNameData = async () => {
        try {
            const response = await axios.get(`${BASE_URL}/project/project-dropdown/${role === "HOD" ? "null" : assignTO}/`);
            setProjectNameList(response.data);
        } catch (error) {
            console.error(error);

        }
    }

    console.log(assignTO)

    const projectNameOptions = [
        ...projectNameList.map((i) => ({
            value: i.pr_code,
            label: `${i.prebid_prcode}-${i.project_short_name}`,
        })),
    ];

 const handleProjectNameChange = (option) => {
        if (!option) {
            setProjectName("null")
        }
        else {
            setProjectName(option.value);
        }
    }


    useEffect(() => {
        getProjectNameData();
    }, [assignTO, role]);

    return (
        <div title="Select role" className="field-cont-div">
            <div style={{ paddingTop: "13px" }}>
                <SearchBig />
            </div>
            <Select
                className="attendance-input-field  date-field"
                options={projectNameOptions}
                value={projectNameOptions.find((i) => i.value === projectName) || { value: "null", label: "Search Project Code/ Name" }}
                onChange={handleProjectNameChange}
                placeholder="Project Name"
                isClearable={projectName !== "null"}
                styles={{
                    control: (provided) => ({
                        ...provided,
                        backgroundColor: "transparent",
                        border: "none",
                        boxShadow: "none",
                        // padding: "0.6rem 0.5rem",
                        textTransform: "capitalize",
                        width: "20vw",
                        top: '8px'
                    }),
                    placeholder: (provided) => ({ ...provided, color: "#707070" }),
                    menu: (provided) => ({ ...provided, zIndex: 9999 }),
                    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                    singleValue: (provided) => ({ ...provided, color: "#707070" }),
                    dropdownIndicator: (provided) => ({
                        ...provided,
                        filter: "invert(50%)",
                        cursor: "pointer",
                        left: "9.5rem",
                        // width: "20px",
                        height: "20px",
                        fontSize: "12px",
                    }),
                    option: (provided, state) => ({
                        ...provided,
                        fontSize: "12px",
                        color: state.isSelected ? "#ffffff" : "#707070",
                        backgroundColor: state.isSelected ? "#2576bc" : state.isFocused ? "#ffffff" : "#fff",
                        cursor: "pointer",
                        "&:hover": { backgroundColor: "#2576bc", color: "#fff" },
                    }),
                }}
            />
            <hr className="field-cont-hrr" />
        </div>
    )
}

export default Projectname;
